import React from "react";

//Dashboard
import Dashboard from "../Pages/Dashboard";

// Import Authentication pages
import Login from "../Pages/Authentication/Login";
import Logout from "../Pages/Authentication/Logout";

import User from "../Pages/User";
import Performance from "../Pages/Performance";
import Machine from "../Pages/Machine";
import Parts from "../Pages/Parts";

import Company from "../Pages/Company";
import Main from "../Pages/MainPage";
import BatchControl from "../Pages/BatchControl/index.js";
import QualityDashboard from "../Pages/QualityDashboard/index.js";
import ProductionPlanning from "../Pages/ProductionPlanning/index.js";
import BatchControlAdminPage from "../Pages/BatchControlAdminPage/index.js";
import ProductionPlanningAdminPage from "../Pages/ProductionPlanningAdminPage/index.js";
import ChildParts from "../Pages/ChildParts/index.js";
import InventoryDetails from "../Pages/Inventory/index.js";
import SpareList from "../Pages/SpareList/index.js";
import AdvancedAnalysis from "../Pages/AdvancedAnalysis/index.js";
import PartSelection from "../Pages/PartSelection/index.js";
import MachineSelection from "../Pages/machineSelection/index.js";
import MachineDownTimeUpdation from "../Pages/MachineDownTimeUpdation/index.js";
import OverView from "../Pages/Dashboard/OverView.js";
import Reports from "../Pages/Reports/index.js";
import MaterialRequest from "../Pages/MaterialRequest/index.js";
import ChildInventoryDetails from "../Pages/ChildPartInventory/index.js";
import VessalControl from "../Pages/VessalControl/index.jsx";
import Operator from "../Pages/Operators/index.js";

import TraceabilityQc from "../Pages/TraceabilityQc/index.js";
import TraceabilityAssemblyProduction from "../Pages/TraceabilityAssemblyProduction/index.js";
import TraceabilityProductionQc from "../Pages/ProductionQc/index.js";
import InventoryUpload from "../Pages/InventoryUpload/index.js";
import { components } from "react-select";
import ClientLeads from "../Pages/ClientLeads/index.js";
import EquipmentList from "../Pages/EquipmentList/index.js";
import Equip2 from "../Pages/Equip2/index.js";
import AddAlarms from "../Pages/AddAlarms/index.js";
import Alarms from "../Pages/Alarms/index.js";
import ClientLeadsData from "../Pages/ClientLeadsData/index.js";
import ExpenseLogin from "../Pages/ExpenseLogin/index.js";
import ExpenseDashboard from "../Pages/ExpenseDashboard/index.js";
import AddExpense from "../Pages/AddExpense/index.js";
import AddExpenseCategory from "../Pages/AddExpenseCatogory/index.js";
import AddProject from "../Pages/AddProject/index.js";
import UploadPaymentProof from "../Pages/UploadPaymentProof/index.js";
import ExpenseUser from "../Pages/ExpenseUser/index.js";
import ProductionReport from "../Pages/ProductionReport/index.js";
import MccPart from "../Pages/MccParts/index.js";
import ProductionDemand from "../Pages/ProductionDemand/index.js";
import TemperatureAlarm from "../Pages/TemperatureAlarm/index.js";
import ListMachines from "../Pages/ListMachines/index.js";
import RouterConfig from "../Pages/RouterConfig/index.js";
import MonthlyShiftStatus from "../Pages/downTimePage/index.js";
import SearchInput from "../Pages/search/index.js";
import FleetRiskDashboard from "../Pages/FleetRisk/index.js";
import RiskTriggerCardSetup from "../Pages/FleetRisk/RiskTriggerCardSetup.js";
import VesselDashboard from "../Pages/VesselDashboard/index.js";
import EngineMonitor from "../Pages/EngineMonitor/index.js";
import Monitor from "../Pages/Monitor/index.js";

const userRoutes = [
  { path: "/", component: <MachineSelection /> },
  { path: "/dashboard", component: <Dashboard /> },
  { path: "/performance", component: <Performance /> },
  
];
const batchControlManagerRoutes = [
  { path: "/batch-control-page", component: <BatchControl /> },
];
const qualityManagerRoutes = [
  { path: "/quality-dashboard", component: <QualityDashboard /> },
];
const productionManagerRoutes = [
  { path: "/production-planning-page", component: <ProductionPlanning /> },
];
const adminRoutes = [
  { path: "/batch-control-page", component: <BatchControl /> },
  { path: "/batch-control", component: <BatchControlAdminPage /> },
  { path: "/quality-dashboard", component: <QualityDashboard /> },
  { path: "/production-planning-page", component: <ProductionPlanning /> },
  { path: "/production-planning", component: <ProductionPlanningAdminPage /> },
  { path: "/user", component: <User /> },
  { path: "/company", component: <Company /> },
  { path: "/machine", component: <Machine /> },
  { path: "/parts", component: <Parts /> },
  { path: "/bom", component: <ChildParts /> },
  { path: "/inventory", component: <InventoryDetails /> },
  { path: "/spare-list", component: <SpareList /> },
  {path: "/advanced-analysis", component: <AdvancedAnalysis /> },
  {path: "/ProductionSetUp", component: <PartSelection/> },
     { path: "/reports", component: <Reports /> },
    {path: "/", component: <MachineSelection/> },
      { path: "/child-parts", component: <ChildParts /> },
      { path: "/material-request", component: <MaterialRequest /> },
          { path: "/client-leads-data", component: <ClientLeadsData /> },
     {path: "/child-parts-inventory", component: <ChildInventoryDetails/> },
    
    {path:"/machine-downtime-updation",component:<MachineDownTimeUpdation/>}
];

const authProtectedRoutes = [
  { path: "/dashboard", component: <Dashboard /> },
  { path: "/batch-control-page", component: <BatchControl /> },
  { path: "/batch-control", component: <BatchControlAdminPage /> },
  { path: "/quality-dashboard", component: <QualityDashboard /> },
  { path: "/production-planning-page", component: <ProductionPlanning /> },
  { path: "/production-planning", component: <ProductionPlanningAdminPage /> },
  { path: "/user", component: <User /> },
  { path: "/performance", component: <Performance /> },
  { path: "/company", component: <Company /> },
  { path: "/machine", component: <Machine /> },
   { path: "/reports", component: <Reports /> },
  { path: "/child-parts", component: <ChildParts /> },
  { path: "/inventory", component: <InventoryDetails /> },
  { path: "/spare-list", component: <SpareList /> },
  {path: "/advanced-analysis", component: <AdvancedAnalysis /> },
  { path: "/", component: <MachineSelection /> },
 {path: "/ProductionSetUp", component: <PartSelection/> },
  {path: "/ProductionReport", component: <ProductionReport/> },
  { path: "/bom", component: <ChildParts /> },
  {path: "/overview", component: <MachineSelection/> },
     {path:"/machine-downtime-updation",component:<MachineDownTimeUpdation/>},
        {path:"/vessalControl",component:<VessalControl/>},
        {path:"/operator",component:<Operator/>},
        {path:"/traceability-assembly-production",component:<TraceabilityAssemblyProduction/>},
  {path:"/traceability-assembly-qc",component:<TraceabilityQc/>},
  {path:"/traceability-production-qc",component:<TraceabilityProductionQc/>},
  {path:"/invetoryupload", component: <InventoryUpload/>},
  {path:"/clientleads",component: <ClientLeads/> },
   {path:"/equipmentList",component: <EquipmentList/> },
    {path:"/equip2",component: <Equip2/> },
     {path:"/alarms",component: <Alarms/> },
      {path:"/addAlarms",component: <AddAlarms/> },
{ path: "/parts", component: <Parts /> },
  {path:"/mccParts",component: <MccPart/> },
 {path:"/productionDemand",component: <ProductionDemand/> },
 {path:"/temperatureTrend",component: <TemperatureAlarm/> },
       {path:"/listMachines",component: <ListMachines/> }, 
        {path:"/router-configuration",component: <RouterConfig/> }, 
         {path:"/downtime-analysis",component: <MonthlyShiftStatus/> },
           {path:"/ai",component:<SearchInput/>},
        { path: "/fleet-risk", component: <FleetRiskDashboard/> },
        { path: "/fleet-risk/trigger-setup", component: <RiskTriggerCardSetup /> },
         { path: "/vesseldashboard", component: <VesselDashboard/> },
           { path: "/engineMonitor", component: <EngineMonitor/> },
   { path: "/monitor", component: <Monitor/> },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  // {
  //   path: "/",
  //   exact: true,
  //   component: <Navigate to="/main" />,
  // },
];

const publicRoutes = [
  { path: "/logout", component: <Logout /> },
  { path: "/Signin", component: <Login /> },
   {path:"/expenseLogin",component: <ExpenseLogin/> },
{path:"/expenseDashboard",component: <ExpenseDashboard/> }, 
   {path:"/addExpense",component: <AddExpense/> },
   {path:"/addExpenseCategory",component: <AddExpenseCategory/> },
      {path:"/addProject",component: <AddProject/> },
      {path:"/uploadPaymentProof",component:<UploadPaymentProof />},
   {path:"/addExpenseUser",component:<ExpenseUser />},
];

export {
  userRoutes,
  batchControlManagerRoutes,
  productionManagerRoutes,
  qualityManagerRoutes,
  adminRoutes,
  authProtectedRoutes,
  publicRoutes,
};
